import React from 'react'
import Container from '../components/Container'
import ContactForm from '../components/ContactForm'
import Title from '../components/Title'


function Hero() {
  return (
    <div className={`relative min-h-[calc(100vh_-_86px)] md:min-h-[calc(100vh_-_106px)] h-full bg-[url('assets/images/heroBg.jpg')] bg-cover bg-center flex items-center`}>
      <div className='bg-black opacity-70 absolute top-0 left-0 w-full h-full'></div>
      <div className='w-full z-10 py-10'>
        <Container>
          <div className='flex gap-10 flex-col lg:flex-row lg:items-center'>
            <div className="basis-3/5 text-center lg:text-left">
              <div className='flex flex-col gap-5'>
                <Title>
                  Schliesswerk Bern GmbH – Ihre Experten für Schliess- und Sicherheitstechnik in Bern
                </Title>
                {/* <div className='md:text-[30px] font-bold text-white'>
                  Call Now for Immediate Assistance
                </div>
                <div className='text-sm md:text-xl text-white'>
                  Whether you're locked out, need new locks installed, or want to upgrade your security, our expert team is here 24/7 to help.
                </div> */}
              </div>
            </div>
            <div className="basis-2/5">
              <ContactForm />
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default Hero